import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdSettingsLanguagePagesRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-settings-language-pages',
	path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?',
};
